<script>
import Swal from "sweetalert2";
import { cloneDeep, drop } from "lodash";
import { required } from "vuelidate/lib/validators";
import EmployeeModal from "@/components/modals/employee.vue";

export default {
    name: "ClusterSignatoryModal",
    components: {
        EmployeeModal,
    },
    data() {
        return {
            submitted: false,
            tableData: [],
            modalTitle: "",
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "type",
            sortDesc: false,
            fields: [
                {
                    key: "fundsAvailableSignatory",
                    label: "Signatory",
                    sortable: true,
                },
                {
                    key: "fundsAvailablePosition",
                    label: "Position",
                    sortable: true,
                },
                {
                    key: "actions",
                    thStyle: { width: "90px" },
                },
            ],
            form: {
                id: 0,
                fundClusterId: 0,
                fundsAvailableSignatory: null,
                fundsAvailablePosition: null,
            },
            indexSelected: -1,
            tableBusy: false,
            selectedFC: null,
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
    },
    validations: {
        form: {
            fundsAvailableSignatory: { required },
        },
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        addSignatory() {
            this.onReset();
            this.modalTitle = "Create New Signatory";
            this.$bvModal.show("signatory-modal");
        },
        onReset() {
            this.form = {
                id: 0,
                fundClusterId: 0,
                fundsAvailableSignatory: null,
                fundsAvailablePosition: null,
            };
        },
        hideModal() {
            this.$bvModal.hide("signatory-modal");
        },
        onCreate() {
            this.submitted = true;
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            let data = cloneDeep(this.form);
            data.fundClusterId = this.selectedFC.id;
            data.campusId = this.$store.state.data.selectedCampus.id;
            if (this.form.id > 0) {
                this.$store
                    .dispatch("fundcluster/UpdateFundClusterSignatory", data)
                    .then((res) => {
                        if(res.data.error){
                            this.showToast(res.data.errorMessage, "error");
                            return;
                        }
                        this.tableData.splice(
                            this.indexSelected,
                            1,
                            this.form
                        );
                        this.$bvModal.hide("signatory-modal");
                        this.showToast("Successfully updated!", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Error updating signatory!",
                            "error"
                        );
                    });
            } else {
                this.$store
                    .dispatch("fundcluster/CreateFundClusterSignatory", data)
                    .then((res) => {
                        if(res.data.error){
                            this.showToast(res.data.errorMessage, "error");
                            return;
                        }
                        this.tableData.push(res.data);
                        this.$bvModal.hide("signatory-modal");
                        this.showToast("Successfully created!", "success");
                    })
                    .catch((err) => {
                        this.showToast(
                            "Error creating signatory!",
                            "error"
                        );
                    });
            }
            this.submitted = false;
        },
        updateItem(props) {
            this.form = cloneDeep(props.item);
            this.indexSelected = this.tableData.indexOf(props.item);
            this.modalTitle = "Update Signatory";
            this.$bvModal.show("signatory-modal");
        },
        deleteItem(props) {
            var index = this.tableData.indexOf(props.item);
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, delete it!",
            }).then((result) => {
                if (result.value) {
                    this.$store
                        .dispatch("fundcluster/DeleteFundClusterSignatory", props.item.id)
                        .then((res) => {
                            if (res.status == 204) {
                                this.tableData.splice(index, 1);
                                this.showToast(
                                    "Successfully deleted!",
                                    "success"
                                );
                            }
                        })
                        .catch((err) => {
                            this.showToast(
                                "Error deleting signatory!",
                                "error"
                            );
                        });
                }
            });
        },
        getData(fc) {
            this.selectedFC = fc;
            this.tableBusy = true;
            this.$store
                .dispatch("fundcluster/GetFundClusterSignatory", 
                    { 
                        fundClusterId: fc.id, 
                        campusId: this.$store.state.data.selectedCampus.id 
                    }
                )
                .then((res) => {
                    this.tableBusy = false;
                    this.tableData = res.data;
                })
                .catch(() => {
                    this.tableBusy = false;
                    this.showToast("Something went wrong!", "error");
                });
        },
        getSignatory() {
            this.$refs.empModal.getSingleSelection();
            this.$bvModal.show("employee-modal");
        },
        dropData(employee) {
            this.form.fundsAvailableSignatory = employee.applicationUser.completeName;
            this.form.fundsAvailableSignatoryPosition = employee.position;
        },
    },
};
</script>

<template>
    <b-modal
        id="cluster-signatory-modal"
        title="Signatory List"
        size="lg"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="row mt-1">
            <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter">
                    <label class="d-inline-flex align-items-center">
                        Search:
                        <b-form-input
                            autocomplete="off"
                            v-model="filter"
                            type="search"
                            placeholder="Search..."
                            class="form-control form-control-sm ms-2"
                        ></b-form-input>
                    </label>
                </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
                <div class="d-flex justify-content-end align-items-center">
                    <button
                        type="button"
                        @click="addSignatory()"
                        class="btn btn-sm btn-info d-flex align-items-center"
                    >
                        <i class="bx bx-plus fs-6"></i>Create New
                    </button>
                    <b-modal
                        id="signatory-modal"
                        :title="modalTitle"
                        size="md"
                        title-class="font-18"
                        hide-footer
                        no-close-on-backdrop
                    >
                        <form
                            @submit.prevent="onCreate"
                            class="needs-validation"
                            ref="accForm"
                        >
                            <div class="mb-3">
                                <label for="companyTypeId">Signatory</label>
                                <b-input-group>
                                    <template #append>
                                        <b-button
                                            @click="getSignatory"
                                            variant="outline-info"
                                            ><i
                                                class="
                                                    mdi
                                                    mdi-clipboard-text-search-outline
                                                "
                                            ></i
                                        ></b-button>
                                    </template>
                                    <input
                                        autocomplete="off"
                                        type="text"
                                        placeholder="Search Company Type..."
                                        class="form-control"
                                        :class="{'is-invalid': submitted && $v.form.fundsAvailableSignatory.$error}"
                                        v-model="form.fundsAvailableSignatory"
                                    />
                                </b-input-group>
                                <div
                                    v-if="
                                        submitted &&
                                        $v.form.fundsAvailableSignatory.$error
                                    "
                                    class="invalid-feedback"
                                >
                                    <span
                                        v-if="
                                            !$v.form.fundsAvailableSignatory
                                                .required
                                        "
                                        >This value is required.</span
                                    >
                                </div>
                            </div>
                            <div class="mb-3">
                                <label for="shortName">Position </label>
                                <input
                                    autocomplete="off"
                                    id="shortName"
                                    type="text"
                                    v-model="form.fundsAvailablePosition"
                                    placeholder="Enter Position..."
                                    class="form-control"
                                />
                            </div>
                            <div class="modal-footer">
                                <button type="submit" class="btn btn-primary">
                                    Save changes
                                </button>
                                <button
                                    type="button"
                                    class="btn btn-link"
                                    @click="hideModal"
                                >
                                    Close
                                </button>
                            </div>
                        </form>
                    </b-modal>
                </div>
            </div>
            <!-- End search -->
        </div>
        <div class="table-responsive mb-0">
            <b-table
                class="datatables"
                :items="tableData"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                :busy="tableBusy"
                @filtered="onFiltered"
                bordered
                outlined
                hover
                striped
                show-empty
                select-mode="single"
                selectable
                selected-variant="success"
            >
                <template #empty="scope">
                    <div class="text-center">{{ scope.emptyText }}</div>
                </template>
                <template #table-busy>
                    <div
                        class="d-flex justify-content-center align-items-center"
                    >
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </template>
                <template #cell(actions)="row">
                    <div class="float-end">
                        <b-dropdown
                            id="dropdown-dropleft"
                            right
                            variant="link"
                            toggle-class="text-decoration-none"
                            menu-class="dropdown-menu-end"
                            no-caret
                        >
                            <template #button-content>
                                <i class="fas fa-ellipsis-v"></i>
                            </template>
                            <b-dropdown-item
                                @click="updateItem(row)"
                                variant="secondary"
                                ><i class="mdi mdi-update font-size-18 me-1"></i
                                >Edit</b-dropdown-item
                            >
                            <b-dropdown-item
                                @click="deleteItem(row)"
                                variant="danger"
                                ><i
                                    class="mdi mdi-trash-can font-size-18 me-1"
                                ></i
                                >Delete</b-dropdown-item
                            >
                        </b-dropdown>
                    </div>
                </template>
            </b-table>
        </div>
        <div class="row">
            <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                    <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                            v-model="currentPage"
                            :total-rows="rows"
                            :per-page="perPage"
                        ></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
        <employee-modal
            ref="empModal"
            @dropData="dropData"
        ></employee-modal>
    </b-modal>
</template>